import React, { useState, useEffect, useCallback } from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Loading from '../../components/bronson/Loading';
import AuctionsList from '../../components/auctions/AuctionsList';
import Traductor from '../../components/Traductor';
import ParseService from '../../services/ParseService';
import AuctionBubbles from './AuctionsBubbles';

import VehicleService from '../../services/VehicleService';
import Globals from '../../Globals';
import useServerTime from 'hooks/useServerTime';
import * as closedBatchesActions from '../../redux/actions/closedBatches';
import useSocketListeners from 'hooks/useSocketListeners';

function AuctionsHome({ history, cookies, setClosedBatches, closedBatches }) {
    const t = new Traductor();
    const [loading, setLoading] = useState(true);
    const [subastasActivas, setsubastasActivas] = useState([]);
    const [proximasSubastas, setproximasSubastas] = useState([]);
    const { serverTime } = useServerTime(true);
    useSocketListeners();

    const rerenderBronsonSlider = useCallback(() => {
        /* FIX FOR BRONSON SLIDER NOT CENTERED ITEMS */
        window.bronson.$$('#auctions-tabs').component('tabs');
        window.bronson
            .$$('.c-cards-slider-container')
            .component('slider')
            .callFirst('toggleSliderControls');
    }, []);

    const GetAgrupations = useCallback(async () => {
        try {
            setLoading(true);
            const response = await new VehicleService().getAgrupations(
                cookies.get(Globals.COOKIES.JWT).AccessToken
            );
            if (response) {
                const agrupaciones = new ParseService().Parse(response.Result);

                if (agrupaciones != null) {
                    if (
                        agrupaciones?.SubastasActuales &&
                        agrupaciones.SubastasActuales.length > 0
                    ) {
                        setsubastasActivas(agrupaciones.SubastasActuales);
                    }
                    if (
                        agrupaciones?.SubastasProximas &&
                        agrupaciones.SubastasProximas.length > 0
                    ) {
                        setproximasSubastas(agrupaciones.SubastasProximas);
                    }
                    if (
                        agrupaciones?.LotesActuales?.length ||
                        agrupaciones?.SubastasProximas?.length
                    ) {
                        const upcomingClosedBatches = agrupaciones?.SubastasProximas
                            ? agrupaciones.SubastasProximas.filter(
                                  e => e.EsLoteCerrado === true
                              )
                            : [];

                        setClosedBatches({
                            active: agrupaciones.LotesActuales,
                            upcoming: upcomingClosedBatches,
                        });
                    }
                }

                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }, [cookies]);

    useEffect(() => {
        GetAgrupations();
    }, [GetAgrupations]);

    useEffect(() => {
        if (subastasActivas.length > 0) {
            rerenderBronsonSlider();
        }
    }, [subastasActivas, rerenderBronsonSlider]);

    useEffect(() => {
        rerenderBronsonSlider();
    }, [closedBatches, rerenderBronsonSlider]);

    return (
        <>
            <div className="o-layout">
                <AuctionBubbles history={history} listItems={subastasActivas} />
                <div className="o-layout__item u-1/1">
                    <p className="u-h3">{t.getTraduction('SubastasActivas')}</p>
                    <AuctionsList
                        listItems={subastasActivas}
                        history={history}
                        loading={loading}
                        type="active"
                        serverTime={serverTime}
                    />
                </div>
                {closedBatches.length > 0 && (
                    <div className="o-layout__item u-1/1 u-mt-large">
                        <p className="u-h3">
                            {t.getTraduction('ClosedBatches')}
                        </p>
                        <AuctionsList
                            listItems={closedBatches}
                            history={history}
                            type="active"
                            serverTime={serverTime}
                        />
                    </div>
                )}
                <div className="o-layout__item u-1/1 u-mt-large">
                    <p className="u-h3">
                        {t.getTraduction('ProximasSubastas')}
                    </p>
                    <AuctionsList
                        listItems={proximasSubastas}
                        history={history}
                        loading={loading}
                        type="upcoming"
                        serverTime={serverTime}
                    />
                </div>
            </div>
            <Loading ariaBusy={loading} disableIcon={true} />
        </>
    );
}

const mapStateToProps = state => ({
    closedBatches: state.closedBatches.closedBatches,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(closedBatchesActions, dispatch),
});

export default withCookies(
    connect(mapStateToProps, mapDispatchToProps)(AuctionsHome)
);
